<mat-card class="termsCard">
    <mat-card-header>
        <mat-card-title>Terms & Conditions</mat-card-title>
        <!--        <mat-card-subtitle>Last Edited DATE</mat-card-subtitle>-->
    </mat-card-header>
    <mat-card-content>
        <div [innerHTML]="this.lastSelectedCommunity?.terms_and_conditions_text_rendered || this.lastSelectedCommunity?.terms_and_conditions"
             class="ck-editorControl"></div>
    </mat-card-content>
</mat-card>
